import { faCheckCircle, faCopy } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";

const CopyButton = ({ text }) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyText = () => {
    navigator.clipboard.writeText(text);
    setIsCopied(true);

    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  return (
    <span>
      {isCopied ? (
        <span className="text-xs ml-1 mb-1 text-gray-500">
          <FontAwesomeIcon className="text-green-600" icon={faCheckCircle} />{" "}
          Copied
        </span>
      ) : (
        <FontAwesomeIcon
          className="ml-2 text-sm mb-1 cursor-pointer text-gray-400"
          onClick={copyText}
          icon={faCopy}
        />
      )}
    </span>
  );
};

export default CopyButton;
